import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage starfield py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-216" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-217" data-mp="30j0vten9sx7b">
        <div className="text-center" data-id="element-218" data-mp="2vpg3a24g4vfi">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-219" data-mp="2voei34tpusk2">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-220" data-mp="39jqnq79eu3fr">
            ¿Cuántas clases más vas a preparar sobre Astronomía sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-221" data-mp="3eiaauazqpl9p">
            Buscás información en internet que no tiene secuencia didáctica ni menciona cómo se ve el cielo desde Argentina.
            Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo orientarse con las
            constelaciones del hemisferio sur, qué es realmente un agujero negro, cómo se detectan exoplanetas, cómo observar un
            eclipse de forma segura, o por qué la Astronomía importa en 2026, no tenés una respuesta que los enganche con la
            realidad de la ciencia astronómica actual.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-222" data-mp="x6cpy4pgrx0g">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-2xl border border-lineDark p-6 sm:p-8" data-id="element-223" data-mp="171ei79f1df79">
          <p className="mb-5 font-display text-xl font-bold text-mutedDark" data-id="element-224" data-mp="3dugvt7gr7oo8">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-225" data-mp="3hv0vahosv4dj">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-226" data-mp="p0sif6klrus1">
                <span className="mt-0.5 shrink-0 rounded-full bg-violet/60 p-1" data-id="element-227" data-mp="k2h86uqebi9a">
                  <XIcon className="h-3.5 w-3.5 text-mutedDark" data-id="element-228" data-mp="y174471hbbw2" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-229" data-mp="17yv3xbdxz9l3">
          ¿Y si esta fuera la última semana que enseñás Astronomía sin tener todo resuelto?
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center leading-relaxed text-mutedDark" data-id="element-230" data-mp="12xxkkvh749i0">
          Con el MEGAPACK ASTRONOMÍA LISTO, tu próxima clase ya empieza diferente. Tus alumnos no aprenden Astronomía como un
          conjunto de conceptos abstractos: aprenden que cada descubrimiento astronómico existe porque la humanidad decidió
          entender el universo.
        </p>
      </div>
    </section>;
}